module.exports = __webpack_public_path__ + "static/media/04-homepage4.2301e607.png";